
<template>
    <div>
   <!--Modal CDR-->
   <v-dialog v-model="cdrOpen" width="90%" class="elevation-0 rounded-0" persistent>
    <v-card class="elevation-0 rounded-0">
      <v-toolbar color="#f7f7f7" class="elevation-0 rounded-0" dense >
        <v-col class="header_modal">
          <v-row><v-toolbar-title>Call Details</v-toolbar-title></v-row>
        </v-col>

        <v-spacer></v-spacer>

        <v-btn
          small
          class="elevation-0 rounded-0"
          icon
         
          @click="closeCDR()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-toolbar v-if="cdrData" class="elevation-0 rounded-0" dense>
        <v-toolbar-subtitle >{{
          cdrData.vessel_number
        }}</v-toolbar-subtitle>
        <v-spacer></v-spacer>
        <v-menu content-class="elevation-0 rounded-0" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              style="border: solid 1px #e0e0e0"
              small
              class="elevation-0 rounded-0"
              color="#ffff"
              v-bind="attrs"
              v-on="on"
            >
              <i class="bx bx-time"></i>
              &nbsp; &nbsp;
              <v-text v-if="cdrData">{{ cdrData.range.label }}</v-text>
              <v-card-text v-if="!cdrData">
                <div class="snippet" data-title=".dot-pulse">
                  <div class="stage">
                    <div class="dot-pulse"></div>
                  </div>
                </div>
              </v-card-text>
              &nbsp; &nbsp;
              <i class="bx bxs-chevron-down"></i>
            </v-btn>
          </template>
          <v-list style="border: solid 1px #e0e0e0">
            <v-list-item>
              <v-btn
                block
                plain
                small
                @click="showCDR('Today', 'today', cdrID)"
                >Today</v-btn
              >
            </v-list-item>
            <v-list-item>
              <v-btn
                block
                plain
                small
                @click="showCDR('This Week', 'week', cdrID)"
                >This Week</v-btn
              >
            </v-list-item>
            <v-list-item>
              <v-btn
                block
                plain
                small
                @click="showCDR('This Month', 'month', cdrID)"
                >This Month</v-btn
              >
            </v-list-item>
            <v-list-item>
              <v-btn
                block
                plain
                small
                @click="showCDR('Last Month', 'lmonth', cdrID)"
                >Last Month</v-btn
              >
            </v-list-item>
            <v-list-item>
              <v-btn
                block
                plain
                small
                @click="(dateopen = true), (datepickerID = cdrID)"
                >Custom Range</v-btn
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-divider v-if="cdrData"></v-divider>

      <v-container style="margin-top:0" v-if="!cdrData" fill-height fluid>
        <v-row align="center" justify="center">
          <v-col
            ><img
              alt="Navplus logo"
              width="70px"
              :src="loadernavplus"
              class="justify-center"
          /></v-col>
        </v-row>
      </v-container>
      <v-card-text>
        <v-row v-if="cdrData" class="mt-4">
          <v-col cols="4">
            <v-card
              class="elevation-0 rounded-0 pa-2"
              style="border: solid 1px #e0e0e0"
            >
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td>Type Terminal</td>
                      <td>: Thuraya Marine Star</td>
                    </tr>
                    <tr>
                      <td>Thuraya Terminal</td>
                      <td>: +{{ cdrData.number }}</td>
                    </tr>
                    <tr>
                      <td>Service Plan</td>
                      <td>: {{ cdrData.paket }}</td>
                    </tr>
                    <tr>
                      <td>Sim Number</td>
                      <td>: {{ cdrData.sim_no }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card
              class="elevation-0 rounded-0 pa-2"
              style="border: solid 1px #e0e0e0"
            >
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td>Allowance</td>
                      <td>: {{ cdrData.stat.allowance }}</td>
                    </tr>
                    <tr>
                      <td>Used Balance</td>
                      <td>
                        <p style="margin-top: 20px">:</p>
                        <v-col style="margin-top: -50px; margin-bottom: 5px"
                          >{{ cdrData.stat.used }} unit ({{
                            cdrData.stat.percentage
                          }}%)<v-progress-linear
                            :value="cdrData.stat.used"
                          ></v-progress-linear
                        ></v-col>
                      </td>
                    </tr>
                    <tr>
                      <td>Remaining Balance</td>
                      <td>: {{ cdrData.stat.balance }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card
              class="elevation-0 rounded-0 pa-2"
              style="border: solid 1px #e0e0e0"
            >
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td>Tracking Allowance</td>
                      <td>: {{ cdrData.stat_track.allowance }}</td>
                    </tr>
                    <tr>
                      <td>Used Balance</td>
                      <td>
                        <p style="margin-top: 20px">:</p>
                        <v-col style="margin-top: -50px; margin-bottom: 5px"
                          >{{ cdrData.stat_track.used }} unit ({{
                            cdrData.stat_track.percentage
                          }}%)<v-progress-linear
                            value="15"
                          ></v-progress-linear
                        ></v-col>
                      </td>
                    </tr>
                    <tr>
                      <td>Remaining Balance</td>
                      <td>: {{ cdrData.stat_track.balance }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card
              class="elevation-0 rounded-0 "
              style="border: solid 1px #e0e0e0;"
            
            >
              <CdrChart
                
                v-if="cdrData.chart"
                v-bind:cdrChart="cdrData.chart"
              />
              <p v-if="!cdrData.chart">Data Not Available</p>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card
              class="elevation-0 rounded-0"
              style="border: solid 1px #e0e0e0"
            >
              <v-toolbar class="elevation-0" color="#F7F7F7" dense>
                <v-menu offset-y content-class="elevation-0 rounded-0 pa-0">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      class="rounded-0 pa-1 elevation-0 ma-0"
                      style="border: solid 1px #e0e0e0"
                      color="#ffff"
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ kFormatter(itemsPerPageCDR)
                      }}<v-icon small style="margin-left: 0.2em"
                        >mdi-unfold-more-horizontal</v-icon
                      >
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="itemsPerPageCDR = 5"
                      ><v-list-item-title>5</v-list-item-title></v-list-item
                    >
                    <v-list-item @click="itemsPerPageCDR = 10"
                      ><v-list-item-title>10</v-list-item-title></v-list-item
                    >
                    <v-list-item @click="itemsPerPageCDR = 15"
                      ><v-list-item-title>15</v-list-item-title></v-list-item
                    >
                    <v-list-item
                      @click="itemsPerPageCDR = cdrData.output.length"
                      ><v-list-item-title>All</v-list-item-title></v-list-item
                    >
                  </v-list>
                </v-menu>
                <v-text-field
                  width="40"
                  light
                  dense
                  v-model="searchCDR"
                  hide-details
                  prepend-inner-icon="mdi-magnify"
                  placeholder="Search"
                  solo
                  class="elevation-0 rounded-0 mt-2 ml-2"
                ></v-text-field>
                <v-spacer style="width: 40%"></v-spacer>

                <v-btn
                  small
                  :color="searchCDR == '' ? 'primary' : '#fff'"
                  class="elevation-0 rounded-0"
                  style="border: solid 1px #e0e0e0"
                  @click="searchCDR = ''"
                  >All</v-btn
                >
                <v-btn
                  small
                  :color="searchCDR == 'telephony' ? 'primary' : '#fff'"
                  class="elevation-0 rounded-0 ml-1"
                  style="border: solid 1px #e0e0e0"
                  @click="searchCDR = 'telephony'"
                  >Voice</v-btn
                >
                <v-btn
                  small
                  :color="searchCDR == 'SMS_CatchAll' ? 'primary' : '#fff'"
                  class="elevation-0 rounded-0 ml-1"
                  style="border: solid 1px #e0e0e0"
                  @click="searchCDR = 'SMS_CatchAll'"
                  >SMS</v-btn
                >
                <v-btn
                  small
                  :color="
                    searchCDR == 'Tracking SMS 8821' ? 'primary' : '#fff'
                  "
                  class="elevation-0 rounded-0 ml-1"
                  style="border: solid 1px #e0e0e0"
                  @click="searchCDR = 'Tracking SMS 8821'"
                  >Tracking</v-btn
                >
              </v-toolbar>
              <v-divider></v-divider>
              <v-data-table
                v-if="cdrData"
                :search="searchCDR"
                :headers="headerscdr"
                :items="cdrData.output"
                :items-per-page="itemsPerPageCDR"
                hide-default-footer
                :page.sync="pageCDR"
                @page-count="pageCountCDR = $event"
                class="elevation-0 dataTable mt-0"
              >
                <template v-slot:item="row">
                  <tr>
                    <!-- <td>{{row.index}}</td> -->
                    <td>{{ row.item.Services }}</td>
                    <td>{{ row.item.MSISDN }}</td>
                    <td>{{ row.item.Type }}</td>
                    <td>{{ row.item.Plcode }}</td>
                    <td>{{ row.item.Network }}</td>
                    <td>{{ row.item.Start_Date }}</td>
                    <td>{{ row.item.Called_Party }}</td>
                    <td>{{ row.item.Duration }}</td>
                    <td>{{ row.item.Band }}</td>
                    <td>{{ row.item.Amount }}</td>
                    <td>{{ row.item.dateTime_local }}</td>
                  </tr>
                </template>
              </v-data-table>
              <div class="pt-0" style="background-color: #F7F7F7">
                <v-pagination
                  color="primary"
                  v-model="pageCDR"
                  :length="pageCountCDR"
                  :total-visible="7"
                ></v-pagination>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
  <!--Modal CDR End-->

  <!--Modal Custom Range-->
  <v-dialog v-model="dateopen" width="25%">
    <v-card color="#1976D2">
      <v-toolbar color="#1976D2" dark>
        <v-toolbar-title>Custom Range</v-toolbar-title>
        <v-spacer></v-spacer
        ><v-btn
          class="mx-2"
          fab
          small
          dark
          color="#0B4281"
          @click="dateopen = false"
        >
          <v-icon dark> mdi-close </v-icon>
        </v-btn></v-toolbar
      >
      <div style="display: block">
        <v-date-picker v-model="dates" range full-width></v-date-picker>

        <v-btn
          @click="customRange(), (dateopen = false), (cdrData = null)"
          style="margin-top: -35px"
          color="primary"
          block
          >Add Range</v-btn
        >
      </div>
    </v-card>
  </v-dialog>
  <!--Modal Custom Range-->
    </div>
</template>

<script>
 import { mapGetters, mapActions } from "vuex";
 import CdrChart from "@/components/charts/CdrChart.vue";
    export default {
        components: {
    CdrChart,
},
        data() {
     return {
        itemsPerPageCDR: 10,
      pageCDR: 1,
      pageCountCDR: 0,
       user_allowed: null,
       loadernavplus: require("@/assets/img/load100new.gif"),
       fetchInterval: null,
       dates: [],
      datepickerID: null,
      dateopen: null,
     };

     
   },  

   methods:{
    ...mapActions([
      "cdrFetch","cdrRemove"]),

      kFormatter(num) {
      return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
        : Math.sign(num) * Math.abs(num);
    },

    customRange() {
      var range_date = this.dates.join(" ");
      const data = {
        id : this.cdrID,
        thuraya_number: this.cdrData.number,
        range: range_date,
        token:  localStorage.getItem("token"),
      };
      this.cdrFetch(data);
    },

    closeCDR(){
        this.cdrRemove()
    }
   },
   computed: {
     ...mapGetters(["cdrData", "cdrID", "cdrOpen"]),
   },
    }
</script>

<style lang="scss" scoped>

</style>






